<template>
  <v-progress-linear
		class="loading index-5 ma-0"
		color="third"
		:indeterminate="true"
		:active="loading"
	/>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed: {
		...mapState(['loading'])
	}
}
</script>

<style lang="scss">
.loading {
	position: fixed !important;
}
</style>

